import { Pipe, PipeTransform } from '@angular/core';

import { Language } from '../../enums/language.enum';

@Pipe({
  name: 'getLanguageIconUrl',
  standalone: true,
})
export class GetLanguageIconUrlPipe implements PipeTransform {
  private readonly folderPath = 'assets/icons/countries';

  private readonly countriesMap: Record<string, string> = {
    [Language.EN]: 'uk',
    [Language.EN_US]: 'us',
    [Language.HI]: 'in',
    [Language.UA]: 'ua',
    [Language.PT_BR]: 'br',
    [Language.SQ]: 'al',
    [Language.HY]: 'am',
    [Language.ZH]: 'cn',
    [Language.ZH_CN]: 'cn',
    [Language.ZH_TW]: 'tw',
    [Language.KA]: 'ge',
    [Language.JA]: 'jp',
    [Language.KK]: 'kz',
    [Language.ES_LA]: 'ar',
    [Language.FA]: 'ir',
    [Language.SR_LATN]: 'rs',
    [Language.SW]: 'ke',
    [Language.ES_MX]: 'mx',
    [Language.CS]: 'cz',
    [Language.DA]: 'dk',
    [Language.EL]: 'gr',
    [Language.KO]: 'kr',
    [Language.BG]: 'bg',
    [Language.HR]: 'hr',
    [Language.NL]: 'nl',
    [Language.HU]: 'hu',
    [Language.IT]: 'it',
    [Language.NO]: 'no',
    [Language.PL]: 'pl',
    [Language.RO]: 'ro',
    [Language.SR]: 'rs',
    [Language.SK]: 'sk',
    [Language.SL]: 'si',
    [Language.SV]: 'se',
    [Language.UZ]: 'uz',
    [Language.AR]: 'sa',
  };

  transform(language?: string): string {
    if (!language) {
      return '';
    }

    return `${this.folderPath}/${this.countriesMap[language] || language}.svg`;
  }
}
